import React, { useState, useEffect } from 'react';
import { getLeadRegistries } from '../api';

const LeadRegistriesRow = ({ lead, loadedRegistries, setLoadedRegistries }) => {
  const [loading, setLoading] = useState(false);
  const registries = loadedRegistries[lead.id] || [];

  useEffect(() => {
    if (!loadedRegistries[lead.id]) {
      loadRegistries();
    }
  }, [lead.id]);

  const loadRegistries = async () => {
    setLoading(true);
    try {
      const data = await getLeadRegistries(lead.id);
      setLoadedRegistries(prev => ({ ...prev, [lead.id]: data || [] }));
    } catch (error) {
      console.error('Error loading registries:', error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div data-testid={`lead-registries-${lead.id}`} style={{ padding: '15px', backgroundColor: '#f8f9fa', borderRadius: '8px', border: '1px solid #e9ecef' }}>
      <div className="d-flex align-items-center mb-3">
        <i className="bi bi-journal-text me-2 text-success"></i>
        <strong className="text-dark" data-testid={`registries-count-${lead.id}`}>Registros ({registries.length})</strong>
      </div>
      
      {loading ? (
        <div className="text-center py-3" data-testid={`registries-loading-${lead.id}`}>
          <div className="spinner-border spinner-border-sm text-success me-2" role="status"></div>
          <span className="text-muted">Cargando registros...</span>
        </div>
      ) : registries.length > 0 ? (
        <div style={{ maxHeight: '300px', overflowY: 'auto' }} data-testid={`registries-list-${lead.id}`}>
          {registries.map((registry, index) => (
            <div key={registry.id || index} className="card mb-2 border-0 shadow-sm" data-testid={`registry-item-${registry.id}`}>
              <div className="card-body p-3">
                <div className="d-flex justify-content-between align-items-start mb-2">
                  <div className="d-flex flex-wrap gap-1">
                    <span className="badge bg-success bg-opacity-10 text-success border border-success" data-testid={`registry-type-${registry.id}`}>
                      {registry.registryType?.name || 'Sin tipo'}
                    </span>
                    {registry.subStatus?.name && (
                      <span className="badge bg-secondary" data-testid={`registry-substatus-${registry.id}`}>
                        {registry.subStatus.name}
                      </span>
                    )}
                  </div>
                  <small className="text-muted" data-testid={`registry-date-${registry.id}`}>
                    {new Date(registry.creationTimestamp).toLocaleString('es-ES', {
                      day: '2-digit',
                      month: '2-digit', 
                      year: 'numeric',
                      hour: '2-digit',
                      minute: '2-digit'
                    })}
                  </small>
                </div>
                <div className="text-dark" data-testid={`registry-comments-${registry.id}`}>{registry.comments}</div>
                {registry.followUpDate && (
                  <div className="mt-2" data-testid={`registry-followup-${registry.id}`}>
                    <small className="text-info">
                      <i className="bi bi-calendar-event me-1"></i>
                      Seguimiento: {new Date(registry.followUpDate).toLocaleDateString('es-ES')}
                    </small>
                  </div>
                )}
              </div>
            </div>
          ))}
        </div>
      ) : (
        <div className="text-center py-3 text-muted" data-testid={`registries-empty-${lead.id}`}>
          <i className="bi bi-journal-x fs-4 d-block mb-2"></i>
          Sin registros
        </div>
      )}
    </div>
  );
};

export default LeadRegistriesRow;